define('models/campaignWatermark',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.CampaignWatermark = T1Model.extend({
    name: "campaign_watermark",
    url: "campaign_watermarks/",
    fixture: "-advertiser"
  });
  return T1.Models.CampaignWatermark;
});
